/** ACT004 打卡热点：是否允许用户点击热点弹出盖章打卡（默认允许） */

export function normalizeAllowClickCheckin(raw) {
  if (raw === 0 || raw === '0' || raw === false) return 0
  if (raw === 'false' || raw === 'FALSE' || raw === 'no' || raw === 'NO') return 0
  if (raw === '否' || raw === 2 || raw === '2') return 0
  return 1
}

/** 从热点对象读取 allowClickCheckin（兼容 snake_case） */
export function readAllowClickCheckinValue(hotspot) {
  if (!hotspot || typeof hotspot !== 'object') return 1
  if (String(hotspot.type) !== '1') return 1
  if (String(hotspot.checkType || 'CHECKIN').toUpperCase() === 'VERIFY') return 1
  let raw = hotspot.allowClickCheckin
  if (raw === undefined || raw === null || raw === '') {
    raw = hotspot.allow_click_checkin
  }
  return normalizeAllowClickCheckin(raw)
}

export function isAct004CheckinPointClickEnabled(hotspot) {
  if (!hotspot) return true
  if (String(hotspot.type) !== '1') return true
  if (String(hotspot.checkType || 'CHECKIN').toUpperCase() === 'VERIFY') return true
  return readAllowClickCheckinValue(hotspot) === 1
}
